import React from 'react';
import { ArcSkeleton, ArcStack } from '@src/core/ui';
import { useParams } from 'react-router-dom';
import { useGetOrderMissionQuery } from '@src/features/order/redux';
import { TakeOffToEnRouteSidebarProps } from './types';
import SidebarTakeOff from './sidebar-take-off';
import SidebarEnRoute from './sidebar-en-route';
import { JoystickView } from './components';
import { OrderStatusType } from '@src/core/features';

const TakeOffToEnRouteSidebar: React.FC<TakeOffToEnRouteSidebarProps> = (props) => {
  const { viewer } = props;

  const { missionId } = useParams();
  const { data, isLoading } = useGetOrderMissionQuery(missionId);

  if (isLoading) {
    return (
      <ArcStack spacing={2}>
        <ArcSkeleton height={50} />
        <ArcSkeleton height={80} />
        <ArcSkeleton height={50} />
        <ArcStack spacing={1} direction='row' justifyContent='center'>
          <ArcSkeleton width={181} height={150} />
          <ArcSkeleton width={181} height={150} />
        </ArcStack>
        <ArcSkeleton height={80} />
        <ArcSkeleton height={80} />
      </ArcStack>
    );
  }

  const renderSidebar = () => {
    if (data?.status === OrderStatusType.READY_FOR_TAKE_OFF) {
      return <SidebarTakeOff viewer={viewer} />;
    }
    if (data?.status === OrderStatusType.EN_ROUTE) {
      return <SidebarEnRoute data={data} viewer={viewer} />;
    }
  };

  return (
    <ArcStack spacing={2}>
      
      {renderSidebar()}

      {viewer ? null : <JoystickView drone={data?.drone} />}

    </ArcStack>
  );
};

export default TakeOffToEnRouteSidebar;